import { UrlHelper } from './UrlHelper';
import { SiteHelper } from './SiteHelper';

const MeetingHelper = {};

MeetingHelper.getLink = (classId) => {
    classId = classId || 'js-virtual-meeting';

   // const container = element.querySelector('.js-virtual-meeting')
   // link = element.querySelector(`.${classId}`);

    const link = document.querySelector(`.${classId}`);



    let url = '';

    if (!link) {
        return url;
    }

    try {
        //add a querystring param to the URL so that mediasite can render the fullsite experience
        const targetLinkAttr = 'data-target-link';
        url = link.getAttribute(targetLinkAttr);

        //try to identify the browser. If it's safari, add a querystring param in the URL so that mediasite can render the full site experience
        const isSafari = SiteHelper.isSafariUser();
        if (isSafari) {
            const query = {
                ua: 'safari'
            };
            url = UrlHelper.updateQueryString(url, query);
        }
    } catch (err) {
        console.error(err);
    }

    return url;
};

export { MeetingHelper };


// WEBPACK FOOTER //
// ./src/nams2020/common/utils/MeetingHelper.js